<style lang="stylus">
    .shape-set-wrapper
        width 100%
        padding: 0 15px 0 16px;
        margin-top 8px
        .shapeset-box
            margin-bottom 16px;
            > div
                padding-top 4px
            p
                border-top none
                height 40px
                line-height 40px
                font-size: 14px;
                font-weight: 700;
                text-align: left;
                color var(--text-color-primary)
            &.disabled
                .block-line .block-input .left
                    color var(--text-color-primary-40);
                    svg
                        opacity 0.4
                .fix-ratio.real
                    cursor not-allowed
                    svg
                        cursor not-allowed
                        opacity 0.4
                .mirror-btn
                    cursor not-allowed
                    .item-icon
                        opacity 0.4
                .layer-wrapper .layer-item
                    cursor not-allowed
                    svg
                        opacity 0.4

        .shapeset-shapebox
            > div
                display flex;
                flex-direction column

            .block-line
                display flex;
                justify-content space-between
                position relative
                &:last-child
                    .block-input
                        margin-bottom 0
                .block-input
                    display flex;
                    align-items center
                    height 24px;
                    margin-bottom 12px
                    &:first-child
                        margin-right 12px;
                    .left
                        height 16px;
                        width 16px;
                        display inline-block
                        margin-right 8px
                        color var(--text-color-primary)
                        font-weight 400
                        svg
                            width 16px;
                            height 16px;
                            color var(--svg-color-primary)
                    .blockinput
                        width 72px;
                .fix-ratio
                    position relative
                    width 24px !important
                    height 24px
                    border-radius 4px
                    svg
                        width 24px
                        height 24px
                        color var(--svg-color-primary)
                    &.real
                        &:hover
                            background-color $common-hover-color
                            cursor pointer
        .shapeset-rotatebox
            &.is-en
                > div
                    display inline-block
                    .mirror-btn
                        width 32px;
                        padding 3px;
                        display inline-block
                        margin-right 12px
                        .mirror-text
                            display none;
            >div
                display flex;
                justify-content space-between
                align-items center
                gap 12px
            .mirror-btn
                display flex;
                align-items center
                cursor pointer
                height 32px;
                flex 1
                border-radius 6px;
                padding 4px 0 4px 16px;
                border 1px solid var(--border-color-box-8)
                &:hover
                    background-color $main-hovercolor
                .item-icon
                    height 24px;
                    width 24px;
                    color var(--svg-color-primary)
                    margin-right 4px
                .mirror-text
                    font-size: 12px;
                    font-weight: 400;
                    line-height: 16px;
                    text-align: left;

        .shapeset-alignbox
            .list-item1
                display flex
                align-items center
                flex-wrap wrap
                cursor pointer
                .align-item
                    margin-right 6px;
                    width 32px
                    height 32px;
                    display flex;
                    align-items center;
                    justify-content center;
                    border 1px solid var(--border-color-box-8)
                    border-radius 6px;
                    &:hover
                        background-color $main-hovercolor
                    &:nth-child(3)
                        margin-right 12px;
                    &:last-child
                        margin-right 0
                svg
                    color var(--svg-color-primary)
                    width 24px;
                    height 24px;
        .shapeset-distributebox
            &.is-en
                .list-item2
                    display inline-block
                    .distribute-item
                        display inline-block
                        margin-right 12px
                        width 32px;
                        padding 3px;
                        span
                            display none
            .list-item2
                display flex
                align-items center
                justify-content space-between
                gap 12px
                .distribute-item
                    display flex;
                    align-items center
                    cursor pointer
                    height 32px;
                    flex 1
                    border-radius 6px;
                    padding 4px 0 4px 10px;
                    border 1px solid var(--border-color-box-8)
                    &:hover
                        background-color $main-hovercolor
                    svg
                        color var(--svg-color-primary)
                        width 24px;
                        height 24px;
                        margin-right 4px
                    span
                        font-size: 12px;
                        font-weight: 400;
                        line-height: 16px;
                        text-align: left;
        .shapeset-layerbox
            &.is-en
                .layer-wrapper
                    display inline-block
                    .layer-item
                        display inline-block
                        margin-right 12px
                        width 32px;
                        padding 3px;
                        span
                            display none
            .layer-wrapper
                display grid;
                grid-template-columns repeat(2, 1fr)
                gap 12px
                .layer-item
                    display flex;
                    align-items center
                    cursor pointer
                    height 32px;
                    flex 1
                    border-radius 6px;
                    padding 4px 0 4px 16px;
                    border 1px solid var(--border-color-box-8)
                    &:hover
                        background-color $main-hovercolor
                    svg
                        color var(--svg-color-primary)
                        width 24px;
                        height 24px;
                        margin-right 4px
                    span
                        font-size: 12px;
                        font-weight: 400;
                        line-height: 16px;
                        text-align: left
</style>

<template>
    <div class="shape-set-wrapper">
        <div class="shapeset-box shapeset-shapebox" :class="{ disabled: !isSelect }">
            <p class="box-title">{{ $t("shape") }}</p>
            <div>
                <div class="block-line">
                    <div class="block-input">
                        <span class="left">W</span>
                        <InputNumber
                            class="blockinput"
                            v-model="shapeWidth"
                            size="small"
                            :disabled="!isSelect"
                            :min="0"
                            :max="20000"
                            :step="['km', 'mi'].includes(pageUnit) ? 0.0001 : 1"
                            :precision="['km', 'mi'].includes(pageUnit) ? 4 : 1"
                            :formatter="(value) => `${value}${pageUnit}`"
                            :parser="(value) => value.replace(/[\sa-zA-Z]*/g, '')"
                            :active-change="false"
                            @on-focus="editLocker('focus', 'lockInput')"
                            @on-blur="
                                editLocker('blur', 'lockInput', () => {
                                    setWidth();
                                })
                            "
                            @on-change="
                                editLocker('edit', 'lockInput', () => {
                                    setWidth();
                                })
                            "
                            @keyup.enter.native="iviewInputBlur($event)"
                        ></InputNumber>
                    </div>
                    <div class="block-input">
                        <span class="left">H</span>
                        <InputNumber
                            class="blockinput"
                            v-model="shapeHeight"
                            :disabled="!isSelect"
                            size="small"
                            :min="0"
                            :max="20000"
                            :step="['km', 'mi'].includes(pageUnit) ? 0.0001 : 1"
                            :precision="['km', 'mi'].includes(pageUnit) ? 4 : 1"
                            :formatter="(value) => `${value}${pageUnit}`"
                            :parser="(value) => value.replace(/[\sa-zA-Z]*/g, '')"
                            :active-change="false"
                            @on-focus="editLocker('focus', 'lockInput')"
                            @on-blur="
                                editLocker('blur', 'lockInput', () => {
                                    setHeight();
                                })
                            "
                            @on-change="
                                editLocker('edit', 'lockInput', () => {
                                    setHeight();
                                })
                            "
                            @keyup.enter.native="iviewInputBlur($event)"
                        ></InputNumber>
                    </div>
                    <div
                        class="fix-ratio real"
                        :class="{ 'actived-btn': fixRatio }"
                        :diyStyle="'z-index:1'"
                        :content="$t('fixRatio')"
                        v-tippy="{ placement: 'bottom' }"
                        @click="
                            () => {
                                isSelect && toggleFixRatio();
                            }
                        "
                    >
                        <iconSymbol :name="fixRatio ? 'fixRatio' : 'fixRatioLock'"></iconSymbol>
                    </div>
                </div>
                <div class="block-line">
                    <div class="block-input">
                        <span class="left">X</span>
                        <InputNumber
                            class="blockinput"
                            v-model="shapeX"
                            :disabled="!isSelect"
                            size="small"
                            :min="0"
                            :max="20000"
                            :step="['km', 'mi'].includes(pageUnit) ? 0.0001 : 1"
                            :precision="['km', 'mi'].includes(pageUnit) ? 4 : 1"
                            :formatter="(value) => `${value}${pageUnit}`"
                            :parser="(value) => value.replace(/[\sa-zA-Z]*/g, '')"
                            :active-change="false"
                            @on-focus="editLocker('focus', 'lockInput')"
                            @on-blur="
                                editLocker('blur', 'lockInput', () => {
                                    setXPosition();
                                })
                            "
                            @on-change="
                                editLocker('edit', 'lockInput', () => {
                                    setXPosition();
                                })
                            "
                            @keyup.enter.native="iviewInputBlur($event)"
                        ></InputNumber>
                    </div>
                    <div class="block-input">
                        <span class="left">Y</span>
                        <InputNumber
                            class="blockinput"
                            v-model="shapeY"
                            :disabled="!isSelect"
                            size="small"
                            :min="0"
                            :max="20000"
                            :step="['km', 'mi'].includes(pageUnit) ? 0.0001 : 1"
                            :precision="['km', 'mi'].includes(pageUnit) ? 4 : 1"
                            :formatter="(value) => `${value}${pageUnit}`"
                            :parser="(value) => value.replace(/[\sa-zA-Z]*/g, '')"
                            :active-change="false"
                            @on-focus="editLocker('focus', 'lockInput')"
                            @on-blur="
                                editLocker('blur', 'lockInput', () => {
                                    setYPosition();
                                })
                            "
                            @on-change="
                                editLocker('edit', 'lockInput', () => {
                                    setYPosition();
                                })
                            "
                            @keyup.enter.native="iviewInputBlur($event)"
                        ></InputNumber>
                    </div>
                    <div class="fix-ratio"></div>
                </div>
                <div class="block-line">
                    <div class="block-input">
                        <span class="left">
                            <iconSymbol name="shape-set-round" />
                        </span>
                        <InputNumber
                            class="input-num blockinput"
                            :max="100"
                            :disabled="!isSelect"
                            :min="0"
                            :step="1"
                            size="small"
                            v-model="RSize"
                            :active-change="false"
                            :formatter="(value) => `${value} mm`"
                            :parser="(value) => value.replace(/[\sa-zA-Z]*/g, '')"
                            @on-focus="editLocker('focus', 'inputLocker')"
                            @on-blur="
                                editLocker('blur', 'inputLocker', () => {
                                    changeRound();
                                })
                            "
                            @on-change="
                                editLocker('edit', 'inputLocker', () => {
                                    changeRound();
                                })
                            "
                            @keyup.enter.native="iviewInputBlur($event)"
                        ></InputNumber>
                    </div>
                    <div class="block-input">
                        <span class="left">
                            <iconSymbol name="shape-set-angle" />
                        </span>
                        <InputNumber
                            class="blockinput"
                            :formatter="(value) => `${value} deg`"
                            :parser="(value) => value.replace(/[\sa-zA-Z]*/g, '')"
                            v-model="rotateNum"
                            :disabled="!canRotate || !isSelect"
                            size="small"
                            :max="360"
                            :min="0"
                            :step="1"
                            @on-focus="editLocker('focus', 'lockInput')"
                            @on-blur="
                                editLocker('blur', 'lockInput', () => {
                                    checkRotateNum();
                                })
                            "
                            @on-change="
                                editLocker('edit', 'lockInput', () => {
                                    checkRotateNum();
                                })
                            "
                            @keyup.enter.native="iviewInputBlur($event)"
                        ></InputNumber>
                    </div>
                    <div class="fix-ratio"></div>
                </div>
            </div>
        </div>
        <div class="shapeset-box shapeset-rotatebox" :class="{ disabled: !isSelect || !canRotate || banMirror, 'is-en': lang !== 'zh' }">
            <p class="box-title">{{ $t("mirror") }}</p>
            <div>
                <div
                    v-tippy="{ placement: 'bottom' }"
                    :content="$t('hMirror')"
                    class="mirror-btn"
                    @click="
                        () => {
                            !isSelect || !canRotate || banMirror ? '' : handleAlignShape(8);
                        }
                    "
                >
                    <iconSymbol class="item-icon" name="new-h-mirror"></iconSymbol>
                    <span class="mirror-text">{{ $t("hMirror") }}</span>
                </div>
                <div
                    v-tippy="{ placement: 'bottom' }"
                    :content="$t('vMirror')"
                    class="mirror-btn"
                    @click="
                        () => {
                            !isSelect || !canRotate || banMirror ? '' : handleAlignShape(9);
                        }
                    "
                >
                    <iconSymbol class="item-icon" name="new-v-mirror"></iconSymbol>
                    <span class="mirror-text">{{ $t("vMirror") }}</span>
                </div>
            </div>
        </div>
        <div class="shapeset-box shapeset-alignbox" v-if="multiSelCount > 1 && isSelect">
            <p class="box-title">{{ $t("align") }}</p>
            <div class="list-item1 border-bottom">
                <div class="align-item" v-for="item in alignList1" :key="item.id" :content="$t(item.text)" v-tippy="{ placement: 'bottom' }">
                    <iconSymbol :name="item.icon" @click.native="isMultiSel && clickBoxItem(item.id, 'alignment')" />
                </div>
            </div>
        </div>
        <div class="shapeset-box shapeset-distributebox" v-if="multiSelCount > 2 && isSelect" :class="{ 'is-en': lang !== 'zh' }">
            <p class="box-title">{{ $t("distribute") }}</p>
            <div class="list-item2">
                <div
                    class="distribute-item"
                    v-for="item in alignList2"
                    :key="item.id"
                    @click="isMultiSel && clickBoxItem(item.id, 'spaceEvenly')"
                    v-tippy="{ placement: 'bottom' }"
                    :content="$t(item.text)"
                >
                    <iconSymbol :name="item.icon" />
                    <span>{{ $t(item.text) }}</span>
                </div>
            </div>
        </div>
        <div class="shapeset-box shapeset-layerbox" :class="{ disabled: !isSelect, 'is-en': lang !== 'zh' }">
            <p class="box-title">{{ $t("layer") }}</p>
            <div class="layer-wrapper">
                <div
                    class="layer-item"
                    v-for="item in layerList"
                    :key="item.id"
                    @click="handleLayer(item.id)"
                    v-tippy="{ placement: 'bottom' }"
                    :content="$t(item.name)"
                >
                    <iconSymbol :name="item.name" />
                    <span>{{ $t(item.name) }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    declare var UnitUtil: any;
    declare var eFmtSetFlag: any;

    import { Component, Prop, Vue, Inject } from "vue-property-decorator";
    let pageUnitList = ["mm", "cm", "m", "km", "in", "ft and in", "ft", "yd", "mi", "pt", "Pica", "Didot", "Cicero", "px"];

    @Component({
        components: {},
    })
    export default class ShapePanel extends Vue {
        @Inject()
        ["iviewInputBlur"];

        setActive(n: number) {
            this.activeType = n;
            this.activeFunc = "";
        }

        alignList1: Array<{ id: number; text: string; icon: string }> = [
            {
                id: 0,
                text: "align01",
                icon: "new-float-multiple-align-1",
            },
            {
                id: 1,
                text: "align02",
                icon: "new-float-multiple-align-2",
            },
            {
                id: 2,
                text: "align03",
                icon: "new-float-multiple-align-3",
            },
            {
                id: 3,
                text: "align04",
                icon: "new-float-multiple-align-4",
            },
            {
                id: 4,
                text: "align05",
                icon: "new-float-multiple-align-5",
            },
            {
                id: 5,
                text: "align06",
                icon: "new-float-multiple-align-6",
            },
        ];
        alignList2: Array<{ id: number; text: string; icon: string }> = [
            {
                id: 6,
                text: "align07",
                icon: "new-float-multiple-align-7",
            },

            {
                id: 7,
                text: "align08",
                icon: "new-float-multiple-align-8",
            },
        ];

        trackStyleSet(type) {
            this.sensors.track("styleSet", {
                Catalogues: "rightMenu Bar",
                shape_tab: type,
            });
        }

        get isSelect() {
            const selectShape = !!this.$store.state.shape.isActived;
            return selectShape;
        }

        get isMultiSel() {
            return this.$store.state.shape.isMultiSel;
        }
        get multiSelCount() {
            return this.$store.state.shape.multiSelCount;
        }

        clickBoxItem(index, type) {
            // 点击内部按钮 控制ui
            let view = window["_view"];
            view.getActiveData();
            this.submitBoxItem(index);
            this.trackStyleSet(type);
        }
        submitBoxItem(index) {
            let view = window["_view"];
            (index < 6 && (view.alignShapes(index), true)) ||
                (index < 8 && (view.distributeShapes(index == 6 ? 0 : 4), true)) ||
                view.flipShape(index == 8);
        }

        layerList: Array<any> = [
            {
                id: 2,
                text: "",
                name: "new-layer3",
                func: "tabsMoveUp",
            },
            {
                id: 3,
                text: "",
                name: "new-layer4",
                func: "tabsMoveDown",
            },
            {
                id: 0,
                text: "",
                name: "new-layer1",
                func: "tabsMoveTop",
            },
            {
                id: 1,
                text: "",
                name: "new-layer2",
                func: "tabsMoveBottom",
            },
        ];

        handleLayer(index) {
            let view = window["_view"];
            view.orderShape(index);
            this.trackStyleSet("layer");
        }

        get banMirror() {
            return this.$store.state.shape.type == "EChartItem";
        }

        get shapeWidth() {
            return this.$store.state.shape.width || 0;
        }
        get shapeHeight() {
            return this.$store.state.shape.height || 0;
        }
        get shapeX() {
            // 暂时使用宽高的值
            return this.$store.state.shape.xPos || 0;
        }
        get shapeY() {
            return this.$store.state.shape.yPos || 0;
        }

        get pageUnit() {
            return pageUnitList[this.$store.state.page.pageUnit];
        }

        set shapeX(v) {
            this.$store.commit("setShapeStatus", {
                type: "xPos",
                data: v,
            });
        }
        set shapeY(v) {
            this.$store.commit("setShapeStatus", {
                type: "yPos",
                data: v,
            });
        }
        set shapeWidth(v) {
            this.$store.commit("setShapeStatus", {
                type: "width",
                data: v,
            });
            if (this.fixRatio) {
                this.$store.commit("setShapeStatus", {
                    type: "height",
                    data: UnitUtil.pixelToUnit(window["_view"]._activeShape.height, this.pUnit + 9),
                });
            }
        }
        set shapeHeight(v) {
            this.$store.commit("setShapeStatus", {
                type: "height",
                data: v,
            });
            if (this.fixRatio) {
                this.$store.commit("setShapeStatus", {
                    type: "width",
                    data: UnitUtil.pixelToUnit(window["_view"]._activeShape.width, this.pUnit + 9),
                });
            }
        }

        get pUnit() {
            return this.$store.state.page.pageUnit;
        }

        get fixRatio() {
            return this.$store.state.shape.WHRatio;
        }
        set fixRatio(v) {
            let view = window["_view"];
            this.$store.commit("setShapeStatus", {
                type: "WHRatio",
                data: v,
            });
            view.protectChanged(2);
            view.setActiveShapeFmt();
        }

        editLocker(type, lock, fn?) {
            let map = new Map([
                [
                    "focus",
                    () => {
                        this[lock] = true;
                    },
                ],
                [
                    "blur",
                    () => {
                        this[lock] = false;
                        fn();
                        this.trackStyleSet("shape");
                    },
                ],
                [
                    "edit",
                    () => {
                        if (!this[lock]) {
                            fn();
                            this.trackStyleSet("shape");
                        }
                    },
                ],
            ]);
            map.get(type)();
        }

        get RSize() {
            return this.$store.state.shape.lineFmt.round;
        }
        set RSize(v) {
            let payload = {
                type: "round",
                data: v,
            };
            this.$store.commit("setLineFmtData", payload);
        }

        changeRound() {
            let v = this.RSize;
            window["_view"]._tool.endEdit();
            let view = window["_view"];
            let payload = {
                _round: v,
            };
            view.setFmt(payload, eFmtSetFlag.LineRound);
        }

        get canRotate() {
            return this.$store.state.shape.canRotate;
        }

        get rotateNum() {
            return (this.$store.state.shape.angle + 360) % 360;
        }
        set rotateNum(v) {
            this.$store.commit("setShapeStatus", {
                type: "angle",
                data: v - 360,
            });
        }

        checkRotateNum() {
            // 检查角度
            this.rotateNum = this.rotateNum < 0 ? 0 : this.rotateNum > 360 ? 360 : this.rotateNum;
            window["_view"].rotateShape(this.rotateNum, true);
            window["_view"].getActiveData();
        }

        setWidth() {
            this.$track("fastTool", "setWidth");
            window["_view"].setShapeSize(this.shapeWidth, "w");
            window["_view"].getActiveData();
        }
        setHeight() {
            this.$track("fastTool", "setHeight");
            window["_view"].setShapeSize(this.shapeHeight, "h");
            window["_view"].getActiveData();
        }
        setXPosition() {
            this.$track("fastTool", "setXPosition");
            window["_view"].setShapePos(this.shapeX, this.shapeY);
            window["_view"].getActiveData();
        }
        setYPosition() {
            this.$track("fastTool", "setYPosition");
            window["_view"].setShapePos(this.shapeX, this.shapeY);
            window["_view"].getActiveData();
        }
        toggleFixRatio() {
            this.$track("fastTool", "toggleFixRatio");
            this.fixRatio = !this.fixRatio;
            this.trackStyleSet("shape");
        }

        handleAlignShape(index) {
            let view = window["_view"];
            view.getActiveData();
            (index < 6 && (view.alignShapes(index), true)) ||
                (index < 8 && (view.distributeShapes(index == 6 ? 0 : 4), true)) ||
                view.flipShape(index == 8);
            this.trackStyleSet("flip");
        }

        get fmtType() {
            return this.$store.state.ui.fmtType;
        }
        get currentSetComponent() {
            if (this.activeType === this.fmtType.fill) {
                return "FillP";
            } else if (this.activeType === this.fmtType.line) {
                return "LineP";
            } else if (this.activeType === this.fmtType.shadow) {
                return "ShadowP";
            }
        }
        get activeType() {
            return this.$store.state.ui.activeType;
        }
        set activeType(v) {
            this.$store.commit("setStatus", {
                type: "activeType",
                data: v,
            });
        }
        get activeFunc() {
            return this.$store.state.ui.activeFunc;
        }
        set activeFunc(v) {
            this.$store.commit("setStatus", {
                type: "activeFunc",
                data: v,
            });
        }

        //生命周期
        mounted() {}

        created() {}
    }
</script>
<i18n>
{
  "zh": {
    "shape": "形状",
    "mirror": "翻转",
    "hMirror": "水平翻转",
    "vMirror": "垂直翻转",
     "align01": "左对齐",
      "align02": "水平居中对齐",
      "align03": "右对齐",
      "align04": "顶部对齐",
      "align05": "垂直居中对齐",
      "align06": "底部对齐",
      "align07": "水平等间距",
      "align08": "垂直等间距",
      "align": "对齐",
      "distribute": "等距分布",
    "width": "W",
    "height": "H",
    "Xd": "X",
    "Yd": "Y",
    "round": "圆角",
    "angle": "角度",
    "fixRatio": "锁定纵横比",
    "layer": "层级",
    "protect": "锁定",
    "new-layer1": "置于顶层",
    "new-layer2": "置于底层",
    "new-layer3": "上移一层",
    "new-layer4": "下移一层"
  },
  "en": {
    "shape": "Shape",
    "mirror": "Flip",
    "hMirror": "Horizontally",
    "vMirror": "Vertically",
     "align01": "Left",
      "align02": "Middle",
      "align03": "Right",
      "align04": "Top",
      "align05": "Center",
      "align06": "Bottom ",
      "align07": "Horizontally",
      "align08": "Vertically",
      "align": "Align",
      "distribute": "Space evenly",
    "width": "宽度",
    "height": "高度",
    "Xd": "X轴",
    "Yd": "Y轴",
    "round": "圆角",
    "angle": "角度",
    "fixRatio": "Lock aspect ratio",
    "layer": "Layer",
    "protect": "Locked",
    "new-layer1": "To front",
    "new-layer2": "To Back",
    "new-layer3": "Forward",
    "new-layer4": "Backward"
  },
  "fr": {
    "shape": "Forme",
    "mirror": "Pivoter",
    "hMirror": "Horizontal",
    "vMirror": "Vertical",
     "align01": "Gauche",
      "align02": "Milieu",
      "align03": "Droite",
      "align04": "Haut",
      "align05": "Centre",
      "align06": "Bas",
      "align07": "Horizontal",
      "align08": "Vertical",
      "align": "Aligner",
      "distribute": "Justifier",
    "layer": "层级",
    "width": "宽度",
    "height": "高度",
    "Xd": "X轴",
    "Yd": "Y轴",
    "round": "圆角",
    "angle": "角度",
    "fixRatio": "Verrouiller le rapport hauteur / largeur",
    "layer": "Niveau",
    "protect": "Protéger",
    "new-layer1": "Vers l'avant",
    "new-layer2": "Vers l'arrière",
    "new-layer3": "Avance",
    "new-layer4": "Retour"
  },
  "de": {
    "shape": "Form",
    "mirror": "Spiegeln",
    "hMirror": "Horizontal",
    "vMirror": "Vertikal",
     "align01": "Links",
      "align02": "Mitte ",
      "align03": "Rechts",
      "align04": "Oben",
      "align05": "Zentrum",
      "align06": "Unten",
      "align07": "Horizontal",
      "align08": "Vertikal",
      "align": "Ausrichten",
      "distribute": "Gleichmäßiger Abstand",
    "layer": "层级",
    "width": "宽度",
    "height": "高度",
    "Xd": "X轴",
    "Yd": "Y轴",
    "round": "圆角",
    "angle": "角度",
    "fixRatio": "Seitenverhältnis sperren",
    "layer": "Ebene",
    "protect": "Schützen",
    "new-layer1": "Nach vorne",
    "new-layer2": "Nach hinten",
    "new-layer3": "Vor",
    "new-layer4": "Zurück"
  },
  "jp": {
    "shape": "形状",
    "mirror": "反転",
    "hMirror": "水平",
    "vMirror": "垂直",
     "align01": "左",
      "align02": "中央",
      "align03": "右",
      "align04": "上",
      "align05": "中央",
      "align06": "下",
      "align07": "水平",
      "align08": "垂直",
      "align": "並び替え",
      "distribute": "均等な間隔",
    "layer": "层级",
    "width": "宽度",
    "height": "高度",
    "Xd": "X轴",
    "Yd": "Y轴",
    "round": "圆角",
    "angle": "角度",
    "fixRatio": "アスペクト比のロック",
    "layer": "レベル",
    "protect": "ロック",
    "new-layer1": "正面",
    "new-layer2": "背面",
    "new-layer3": "前方",
    "new-layer4": "後方"

  },
  "es": {
    "shape": "Forma",
    "mirror": "Girar",
    "hMirror": "En horizontal",
    "vMirror": "En vertical",
     "align01": "Izquierda",
      "align02": "Medio",
      "align03": "Derecha",
      "align04": "Arriba",
      "align05": "Centro",
      "align06": "Inferior",
      "align07": "En horizontal",
      "align08": "En vertical",
      "align": "Alinear",
      "distribute": "Espaciar uniformemente",
    "layer": "层级",
    "width": "宽度",
    "height": "高度",
    "Xd": "X轴",
    "Yd": "Y轴",
    "round": "圆角",
    "angle": "角度",
    "fixRatio": "Bloquee la relación de aspecto",
    "layer": "Capa",
    "protect": "Proteger",
    "new-layer1": "Hacia delante",
    "new-layer2": "Hacia atrás",
    "new-layer3": "Avanzar",
    "new-layer4": "Retroceder"
  },
  "pt": {
    "shape": "Forma",
    "mirror": "Inverter",
    "hMirror": "Horizontalmente",
    "vMirror": "Verticalmente",
    "align01": "Esquerda",
      "align02": "Meio",
      "align03": "Direita",
      "align04": "Acima",
      "align05": "Centro",
      "align06": "Abaixo",
      "align07": "Horizontalmente",
      "align08": "Verticalmente",
      "align": "Alinhar",
      "distribute": "Espaçar uniformemente",
    "layer": "层级",
    "width": "宽度",
    "height": "高度",
    "Xd": "X轴",
    "Yd": "Y轴",
    "round": "圆角",
    "angle": "角度",
    "fixRatio": "Bloquear relação de aspecto",
    "layer": "Camada",
    "protect": "Bloqueado",
    "new-layer1": "Para frente",
    "new-layer2": "Para trás",
    "new-layer3": "Avançar",
    "new-layer4": "Retroceder"
  },
  "it": {
    "shape": "Forma",
    "mirror": "Capovolgi",
    "hMirror": "Orizzontalmente",
    "vMirror": "Verticalmente",
     "align01": "A sinistra",
      "align02": "In mezzo",
      "align03": "A destra",
      "align04": "In alto",
      "align05": "Al centro",
      "align06": "In basso",
      "align07": "Orizzontalmente",
      "align08": "Verticalmente",
      "align": "Allinea",
      "distribute": "Spaziatura uniforme",
    "layer": "层级",
    "width": "宽度",
    "height": "高度",
    "Xd": "X轴",
    "Yd": "Y轴",
    "round": "圆角",
    "angle": "角度",
    "fixRatio": "Blocca Rapporto di Aspetto",
    "layer": "Livello",
    "protect": "Bloccato",
    "new-layer1": "Porta avanti",
    "new-layer2": "Porta indietro",
    "new-layer3": "Avanti",
    "new-layer4": "Indietro"
  },
  "tw": {
    "rotate": "翻转",
    "hMirror": "",
    "vMirror": "",
     "align01": "左對齊",
      "align02": "居中對齊",
      "align03": "右對齊",
      "align04": "頂部對齊",
      "align05": "居中對齊",
      "align06": "底部對齊",
      "align07": "水平等間距",
      "align08": "垂直等間距",
      "align": "對齊",
      "distribute": "分佈",
    "layer": "层级",
    "width": "宽度",
    "height": "高度",
    "Xd": "X轴",
    "Yd": "Y轴",
    "round": "圆角",
    "angle": "角度",
    "fixRatio": "鎖定縱橫比",
    "layer": "層級",
    "protect": "鎖定",
    "new-layer1": "移至頂部",
    "new-layer2": "移至底部",
    "new-layer3": "上移一層",
    "new-layer4": "下移一層"
  }
}
</i18n>
